// extracted by mini-css-extract-plugin
export default {"loader":"ClaimTraitInProgress_loader__cya2e","container":"ClaimTraitInProgress_container__0OfMh","loading":"ClaimTraitInProgress_loading__FbVW6"};